import { useEffect, useRef } from "react";

export const TweetEmbed = ({ url, testId }) => {
  const ref = useRef(null);

  useEffect(() => {
    const render = () => window.twttr?.widgets?.load(ref.current);
    if (window.twttr?.widgets) {
      render();
    } else {
      let s = document.getElementById("twitter-wjs");
      if (!s) {
        s = document.createElement("script");
        s.id = "twitter-wjs";
        s.src = "https://platform.twitter.com/widgets.js";
        s.async = true;
        document.body.appendChild(s);
      }
      s.addEventListener("load", render);
      return () => s.removeEventListener("load", render);
    }
  }, []);

  return (
    <div
      ref={ref}
      data-testid={testId}
      className="break-inside-avoid mb-6 lg:mb-8 neon-card px-3 py-1 [&_.twitter-tweet]:!my-2"
    >
      <blockquote className="twitter-tweet" data-theme="dark" data-dnt="true">
        <a href={url}>View post on X</a>
      </blockquote>
    </div>
  );
};
